import React from 'react';
import app from 'general/js/app';

import CustomEventLeaderboardTable from './custom-event-leaderboard-table';
import CustomEventLeaderboardHeader from './custom-event-leaderboard-header';

class CustomEventLeaderboardContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSortingAscending: true
        };
    }

    render() {
        const {
            scoringLeaderboard,
            scoringCourse,
            options
        } = this.props;

        return (
            <div>
                <CustomEventLeaderboardHeader
                    logo={options.customEventLeaderboardDatasource.logo}
                    patronLogo={options.customEventLeaderboardDatasource.patronLogo}
                ></CustomEventLeaderboardHeader>
                <CustomEventLeaderboardTable
                    options={options}
                    scoringCourse={scoringCourse}
                    currentRound={1}
                    players={scoringLeaderboard.players}
                ></CustomEventLeaderboardTable>
            </div>
        );
    }
}

export default CustomEventLeaderboardContainer;
